module.exports = __webpack_public_path__ + "img/dot.4e0b3d5c.svg";